/**
 * groupAlpha — fade a container as ONE flattened image.
 *
 * Setting `container.alpha` multiplies into every child, so overlapping
 * children (the weapon sits under the body sprite) are each drawn at that alpha
 * and the weapon shows through the body. An alpha *filter* renders the children
 * opaque into an offscreen texture first and fades the result, so the body
 * occludes the weapon exactly as it does at full opacity.
 *
 * Kept free of pixi imports so it can be unit tested; the caller passes a
 * factory for the filter (e.g. `() => new PIXI.AlphaFilter()`).
 *
 * @param {object} container a pixi container (needs `alpha`, `filters`)
 * @param {number} alpha 0..1
 * @param {() => {alpha: number}} createFilter builds an alpha filter
 */
export function setGroupAlpha(container, alpha, createFilter) {
  container.alpha = 1;
  if (alpha >= 1) {
    // Fully opaque: skip the offscreen pass entirely.
    if (container.filters) container.filters = null;
    return;
  }
  let filter = container._groupAlphaFilter;
  if (!filter) {
    filter = createFilter();
    container._groupAlphaFilter = filter;
  }
  filter.alpha = alpha;
  container.filters = [filter];
}
